/* eslint-disable import/prefer-default-export */
import { ROOT_SLICE_PLATFORM } from '../constants';

export const selectRootSlicePlatform = state => {
	return state[ROOT_SLICE_PLATFORM] || state
};
